import React, { Fragment } from 'react';
import Navbar from '../../components/Navbar/Navbar'
import PageTitle from '../../components/pagetitle/PageTitle'
import Scrollbar from '../../components/scrollbar/scrollbar'
import Footer from '../../components/footer/Footer.js'
import Slider from "react-slick"
import ProductTabs from '../../components/ProductTabs'
import SEO from '../../components/SEO/SEO';
import { seoData } from '../../utils/seoData';

const DiMethylSulphatePage = () => {

    const productData = {
        description: [
            "Dimethyl Sulfate (DMS) is a highly reactive methylating agent with the chemical formula (CH₃)₂SO₄. It is a colorless, oily liquid widely used in organic synthesis, pharmaceutical manufacturing, and chemical production. Known for its efficiency in methylation reactions, DMS is essential in producing various industrial chemicals.",
            "Supplied in high purity with strict quality control to ensure safe handling and optimal performance in chemical processes.",
            "• Drums: typically 200 L or 250 L steel drums with corrosion-resistant lining and proper sealing — standard for industrial chemical transport.",
            "• Intermediate Bulk Containers (IBC): 1000 L containers for medium to large-scale operations with secure handling systems.",
            "• ISO tank containers: for bulk international transport with temperature control and safety monitoring.",
            "• Specialized packaging: all containers meet UN/DOT hazardous material regulations with proper labeling and safety documentation.",
            "• Packing & labeling: supplied with comprehensive Safety Data Sheets (SDS), handling instructions, and emergency response information. Temperature-controlled storage and transport required to maintain product stability."
        ],
        applications: [
            {
                id: 1,
                title: "Pharmaceutical Manufacturing",
                description: "Dimethyl Sulfate is extensively used as a methylating agent in pharmaceutical synthesis. It plays a crucial role in producing active pharmaceutical ingredients (APIs), intermediates, and specialty drugs requiring precise methylation reactions.",
                image: "/images/products/di-methyl-sulphate/pharma.jpg"
            },
            {
                id: 2,
                title: "Agrochemical Production",
                description: "Used in manufacturing pesticides, herbicides, and fungicides. DMS is essential for synthesizing methylated compounds used in crop protection chemicals and agricultural formulations.",
                image: "/images/products/di-methyl-sulphate/agro.jpg"
            },
            {
                id: 3,
                title: "Dye & Pigment Industry",
                description: "Applied in the production of dyes, pigments, and colorants. Dimethyl Sulfate facilitates methylation reactions necessary for creating various synthetic dyes used in textiles, printing, and industrial applications.",
                image: "/images/products/di-methyl-sulphate/dye.jpg"
            },
            {
                id: 4,
                title: "Chemical Synthesis & Intermediates",
                description: "Key reagent in organic synthesis for producing methylated compounds, quaternary ammonium salts, and specialty chemicals. Used in manufacturing surfactants, polymers, and various industrial chemical intermediates.",
                image: "/images/products/di-methyl-sulphate/chemical.jpg"
            }
        ]
    };

    return (
        <Fragment>
            <SEO title={seoData.dimethylSulphate.title} description={seoData.dimethylSulphate.description} keywords={seoData.dimethylSulphate.keywords} />
            <Navbar/>
            <PageTitle pageTitle="Di Methyl Sulphate" pagesub="Di Methyl Sulphate" parentPage="Products" parentLink="#" />
            <div className="team-pg-area product-page-section">
                <div className="container">
                    <div className="team-info-wrap">
                        <div className="row align-items-center">
                            <div className="col-lg-6">
                                <div className="team-info-img">
                                    <Slider dots={true} arrows={true} infinite={true} speed={500} slidesToShow={1} slidesToScroll={1} autoplay={true} autoplaySpeed={3000}>
                                        <div className="image-box">
                                            <img src='/images/products/di-methyl-sulphate/d1.jpg' alt="Di Methyl Sulphate" />
                                        </div>
                                        <div className="image-box">
                                            <img src='/images/products/di-methyl-sulphate/d2.jpg' alt="Di Methyl Sulphate Drums" />
                                        </div>
                                        <div className="image-box">
                                            <img src='/images/products/di-methyl-sulphate/d3.jpg' alt="Di Methyl Sulphate Storage" />
                                        </div>
                                    </Slider>
                                </div>
                            </div>
                            <div className="col-lg-6">
                                <div className="team-info-text">
                                    <h2>Dimethyl Sulfate (DMS)</h2>
                                    <ul>
                                        <li>Chemical Formula: <span>(CH₃)₂SO₄</span></li>
                                        <li>Purity: <span>99%+</span></li>
                                        <li>Appearance: <span>Colorless Liquid</span></li>
                                        <li>Packaging: <span>200L, 250L Drums, IBC</span></li>
                                        <li>CAS Number: <span>77-78-1</span></li>
                                        <li>Molecular Weight: <span>126.13 g/mol</span></li>
                                        <li>Grade: <span>Industrial/Technical</span></li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                    <ProductTabs product={productData} />
                </div>
            </div>
            <Footer/>
            <Scrollbar/>
        </Fragment>
    )
};

export default DiMethylSulphatePage;
